import * as types from "./types.js"
import * as api from "./api.js"


function getCitizenshipsRequest() {
    return {
        type: types.GET_CITIZENSHIPS_REQUEST
    }
}

function getCitizenshipsReceived(citizenships) {
    return {
        type: types.GET_CITIZENSHIPS_RECEIVED,
        payload: citizenships
    }
}

function getCitizenshipsError(e) {
    return {
        type: types.GET_CITIZENSHIPS_ERROR,
        payload: e,
        error: true
    }
}

export function getCitizenships(personid) {
    return dispatch => {
        dispatch(getCitizenshipsRequest())
        return api.getCitizenships(personid)
        .then(res => {
            if (res.status !== 200) {
                dispatch(getCitizenshipsError(res.statusText))
            } else {
                return res.json()
                .then(citizenships => {
                    dispatch(getCitizenshipsReceived(citizenships))
                })
            }
        })
    }
}


function postCitizenshipRequest() {
    return {
        type: types.POST_CITIZENSHIP_REQUEST
    }
}

function postCitizenshipReceived(citizenship) {
    return {
        type: types.POST_CITIZENSHIP_RECEIVED,
        payload: citizenship
    }
}

function postCitizenshipError(e) {
    return {
        type: types.POST_CITIZENSHIP_ERROR,
        payload: e,
        error: true
    }
}

export function postCitizenship(citizenship) {
    return dispatch => {
        dispatch(postCitizenshipRequest())
        return api.postCitizenship(citizenship)
        .then(res => {
            if (res.status !== 200) {
                dispatch(postCitizenshipError(res.statusText))
            } else {
                return res.json()
                .then(stats => {
                    dispatch(postCitizenshipReceived({
                        id: stats.id,
                        citizenship: citizenship.citizenship
                    }))
                })
            }
        })
    }
}

function deleteCitizenshipRequest() {
    return {
        type: types.DELETE_CITIZENSHIP_REQUEST
    }
}

function deleteCitizenshipReceived(citizenship) {
    return {
        type: types.DELETE_CITIZENSHIP_RECEIVED,
        payload: citizenship
    }
}

function deleteCitizenshipError(e) {
    return {
        type: types.DELETE_CITIZENSHIP_ERROR,
        payload: e,
        error: true
    }
}

export function deleteCitizenship(id) {
    return dispatch => {
        dispatch(deleteCitizenshipRequest())
        return api.deleteCitizenship(id)
        .then(res => {
            if (res.status !== 200) {
                dispatch(deleteCitizenshipError(res.statusText))
            } else {
                return res.json()
                .then(stats => {
                    dispatch(deleteCitizenshipReceived({ id }))
                })
            }
        })
    }
}


/** WEBPACK FOOTER **
 ** ./src/actions/profile/citizenship/actions.js
 **/